import {
  checkDiscountAppliedValidWhenPaymentMethodChangeAfterTxnCreated,
  fetchDiscountsAvailable,
  getDiscountDefault,
} from 'components/Discount/func';
import { PORTAL_NAME_MODAL_DEFINE } from 'components/common/PortalModal/config';
import {
  ADD_TRANSACTION_PAYMENT_METHOD_INSTRUCTION,
  ADD_TRANSACTION_PAYMENT_METHOD_INSTRUCTION_LINK,
  ADD_TRANSACTION_PAYMENT_METHOD_NAME,
  ADD_TRANSACTION_PAYOUT_METHOD_NAME,
  ADD_TRANSACTION_RECEIVER_GET_NAME,
  ADD_TRANSACTION_YOU_SEND_ANOTHER_NAME,
  ADD_TRANSACTION_YOU_SEND_NAME,
  DESKTOP_MIN_WIDTH,
  HHMT_EMAIL,
  HHMT_PHONE,
  HOME_URL,
  METHOD_DEPOSIT,
  METHOD_EPAYMENT,
  METHOD_PAYID,
  METHOD_PAYTO,
  METHOD_POLI,
  REMOX_EMAIL,
  REMOX_PHONE,
  RESET_ADD_TRANSACTION_INFORMATION_STORE,
  STATUS_CANCELLED,
  STATUS_FAIL,
} from 'constants';
import { QuestionIcon } from 'constants/icon';
import withAddPaytoAccountsAgreement from 'features/to/HOCs/payment/withAddPaytoAccountsAgreement';
import PaytoBodyContent from 'features/to/components/payment/payto/PaytoBodyContent';
import usePayment from 'features/to/hooks/payment/usePayment';
import usePayto from 'features/to/hooks/payment/usePayto';
import usePaytoStore from 'features/to/hooks/payment/usePaytoStore';
import { format } from 'helpers';
import Cookies from 'helpers/cookies';
import { MAKE_PAYMENT_KEY } from 'hooks/form-add-transaction/useAddTransaction';
import useFormAddTransactionStore from 'hooks/form-add-transaction/useFormAddTransactionStore';
import useCheckServiceAlerts from 'hooks/service-alerts/useCheckServiceAlerts';
import useServiceAlertsConfig from 'hooks/service-alerts/useServiceAlertsConfig';
import useServiceAlertsStore from 'hooks/service-alerts/useServiceAlertsStore';
import useAuth from 'hooks/useAuth';
import useLang from 'hooks/useLang';
import usePortalModal from 'hooks/usePortalModal';
import useQuery from 'hooks/useQuery';
import useStore from 'hooks/useStore';
import useTheme from 'hooks/useTheme';
import { isArray, isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import { SET_ADD_TRANSACTION_INFORMATION } from 'store/action';
import styled from 'styled-components';
import { numberUtils, stringUtils } from 'utils';
import UrgentPopup from '../../../UrgentPopup';

const initialFormField = RESET_ADD_TRANSACTION_INFORMATION_STORE.paymentMethod;

const PaymentMethodItem = withAddPaytoAccountsAgreement(
  ({
    countryCode,
    method,
    information,
    setInformation,
    validation,
    setValidation,
    payLimit,
    isDisabled,
    isSelectRequired,
    onSelect: onSelectPaytoAccountAgreement,
  }) => {
    const { t, locate } = useLang();
    const { state, dispatch } = useStore();
    const {
      currentReceiver,
      paytoAccountsAgreement,
      addTransactionInformation,
    } = state;
    const {
      receiverPayoutMethod,
      remittance,
      paymentMethod: paymentMethodStore,
    } = addTransactionInformation || {};
    const { isHHMTTheme, theme } = useTheme();
    const { token } = useAuth();
    const query = useQuery();

    const [isShowUrgentPopup, setShowUrgentPopup] = useState(false);

    const { showPortalModalName } = usePortalModal();
    const { onShowAddPaytoAccountModal } = usePayto();
    const { preventPaymentMethodSelection } = usePayment();

    const { paymentMethod } = useServiceAlertsConfig();

    const { resetPaymentMethod } = useFormAddTransactionStore();
    const { serviceAlertsByPayments: serviceAlertsStore } =
      useServiceAlertsStore();
    const { checkByPaymentMethod } = useCheckServiceAlerts();
    const { checkServiceAlertsOfPaymentMethodItemDisable } =
      checkByPaymentMethod || {};
    const isServiceAlertsOfPaymentMethodItemDisable =
      checkServiceAlertsOfPaymentMethodItemDisable({
        serviceAlertsStore,
        paymentMethod: method?.method,
      });

    const { resetPaytoAccountsAgreement } = usePaytoStore();

    const isSelected =
      !isServiceAlertsOfPaymentMethodItemDisable &&
      information[ADD_TRANSACTION_PAYMENT_METHOD_NAME] === method?.method;

    const isPayLimit = isDisabled && !isServiceAlertsOfPaymentMethodItemDisable;

    const payoutMethod =
      receiverPayoutMethod[ADD_TRANSACTION_PAYOUT_METHOD_NAME];

    const currencyCode = remittance?.currentCurrencySelected?.currencyCode;

    const isOnlyCurrency = !remittance.isAddAnotherReceivingCurrency;

    const sendAmount = numberUtils.mathRound(
      remittance[ADD_TRANSACTION_YOU_SEND_NAME] || 0
    );
    const sendAnotherAmount = numberUtils.mathRound(
      remittance[ADD_TRANSACTION_YOU_SEND_ANOTHER_NAME] || 0
    );
    const sendTotalAmount = numberUtils.mathRound(
      sendAmount + sendAnotherAmount
    );

    const receiverAmount = Number(
      remittance[ADD_TRANSACTION_RECEIVER_GET_NAME] || 0
    );

    const {
      discountApplied,
      discountsAvailable,
      discountsInactive,
      discountDetails,
    } = paymentMethodStore || {};
    const discountDefault = getDiscountDefault({
      discountsAvailable,
      discountsInactive,
    });

    const paymentStatus = query.get('paymentStatus');
    const refNumber = query.get('refNumber');
    const isMakePayment = Cookies.get(MAKE_PAYMENT_KEY) || refNumber;
    const isUpdateTxn =
      paymentStatus === STATUS_FAIL ||
      paymentStatus === STATUS_CANCELLED ||
      isMakePayment;

    const getDiscountsAvailable = (paymentMethod) => {
      if (paymentMethod) {
        fetchDiscountsAvailable({
          token,
          countryCode,
          payoutMethod,
          currencyCode,
          isOnlyCurrency,
          sendAmount: sendTotalAmount,
          receiverAmount,
          paymentMethod,
          cityId: currentReceiver?.address?.city?.id,
        });
      }
    };

    useEffect(() => {
      if (!isUpdateTxn && isSelected && paymentMethod && !discountApplied) {
        // getDiscountsAvailable(paymentMethod);
      }
    }, [isSelected, paymentMethod]);

    const paymentMethodOnSelectReferences = {
      [METHOD_PAYTO]: () => {
        if (isDisabled) {
          console.log(
            `⭐ PaymentMethodItem 👉 METHOD_PAYTO ➡️ onSelect ➡️ isDisabled ↩`
          );
        } else {
          console.log(`⭐ PaymentMethodItem 👉 METHOD_PAYTO ➡️ onSelect ↩`);
          onSelectPaytoAccountAgreement();
        }
      },
      [METHOD_PAYID]: () => {
        console.log(`⭐ PaymentMethodItem 👉 METHOD_PAYID ➡️ onSelect ↩`);
        resetPaytoAccountsAgreement();
      },
      [METHOD_DEPOSIT]: () => {
        console.log(`⭐ PaymentMethodItem 👉 METHOD_DEPOSIT ➡️ onSelect ↩`);
        resetPaytoAccountsAgreement();
      },
      [METHOD_EPAYMENT]: () => {
        console.log(`⭐ PaymentMethodItem 👉 METHOD_EPAYMENT ➡️ onSelect ↩`);
        resetPaytoAccountsAgreement();
      },
    };
    const handlePaymentMethodSelected = (e, method) => {
      console.log(
        `⭐ PaymentMethodItem 👉 handlePaymentMethodSelected ➡️ CLICK ↩`
      );
      if (
        e?.target?.tagName === 'IMG' &&
        e?.target?.className?.includes('question-icon')
      ) {
        console.log(
          `⭐ PaymentMethodItem 👉 handlePaymentMethodSelected ➡️ return 1 ↩`
        );
        return;
      }

      if (preventPaymentMethodSelection(e, method)) {
        console.log(
          `⭐ PaymentMethodItem 👉 handlePaymentMethodSelected ➡️ return 2 ↩`
        );
        return;
      }

      const isPaytoBlocked =
        method === METHOD_PAYTO &&
        isArray(paytoAccountsAgreement) &&
        paytoAccountsAgreement?.some(
          (accountAgreement) => accountAgreement?.blocked
        );
      if (isPaytoBlocked) {
        console.log(
          `⭐ PaymentMethodItem 👉 handlePaymentMethodSelected ➡️ return 3 ↩`
        );
        return;
      }

      paymentMethodOnSelectReferences?.[method]?.();

      const newInformation = {
        ...information,
        [ADD_TRANSACTION_PAYMENT_METHOD_NAME]: method,
      };

      const isCheckDiscountAppliedAfterTxnCreated =
        checkDiscountAppliedValidWhenPaymentMethodChangeAfterTxnCreated({
          isUpdateTxn,
          discount: discountDetails,
          currentPaymentMethodSelected: method,
        });

      setInformation(newInformation);

      setValidation(initialFormField);

      dispatch({
        type: SET_ADD_TRANSACTION_INFORMATION,
        payload: {
          ...addTransactionInformation,
          paymentMethod: {
            ...addTransactionInformation.paymentMethod,
            ...newInformation,
            ...(paymentMethod &&
              isEmpty(discountDefault) && {
                discountsAvailable: [],
                discountsInactive: [],
              }),
            ...(paymentMethod &&
              isEmpty(discountDefault) &&
              isEmpty(discountApplied) &&
              !isCheckDiscountAppliedAfterTxnCreated && {
                discountApplied: null,
              }),
          },
        },
      });

      if (method === METHOD_POLI) {
        setShowUrgentPopup(true);
      }
    };

    const handlePaymentMethodDisabledSelected = (e) => {
      console.log(
        `⭐ PaymentMethodItem 👉 handlePaymentMethodDisabledSelected ➡️ CLICK ↩`
      );
      if (
        (e?.target?.tagName === 'IMG' &&
          e?.target?.className?.includes('question-icon')) ||
        e?.target?.className?.includes('payto-disable-details')
      ) {
        console.log(
          `⭐ PaymentMethodItem 👉 handlePaymentMethodDisabledSelected ➡️ return ↩`
        );
        return;
      }

      const newInformation = {
        ...information,
        [ADD_TRANSACTION_PAYMENT_METHOD_NAME]: '',
      };
      setInformation(newInformation);

      const isPaytoBlocked =
        method?.method === METHOD_PAYTO &&
        isArray(paytoAccountsAgreement) &&
        paytoAccountsAgreement?.some(
          (accountAgreement) => accountAgreement?.blocked
        );
      if (isPaytoBlocked) {
        dispatch({
          type: SET_ADD_TRANSACTION_INFORMATION,
          payload: {
            ...addTransactionInformation,
            paymentMethod: {
              ...addTransactionInformation.paymentMethod,
              [ADD_TRANSACTION_PAYMENT_METHOD_NAME]: '',
            },
          },
        });
      } else {
        dispatch({
          type: SET_ADD_TRANSACTION_INFORMATION,
          payload: {
            ...addTransactionInformation,
            paymentMethod: {
              ...addTransactionInformation.paymentMethod,
              [ADD_TRANSACTION_PAYMENT_METHOD_NAME]: method?.method,
            },
          },
        });
      }
    };

    const handleShowPaymentInstructionModal = () => {
      showPortalModalName({
        name: PORTAL_NAME_MODAL_DEFINE.PAYMENT_INSTRUCTION_MODAL,
        content: (
          <InstructionBodyContent
            dangerouslySetInnerHTML={{
              __html: stringUtils.replaceKeyword(
                t(ADD_TRANSACTION_PAYMENT_METHOD_INSTRUCTION[method?.method], {
                  email: isHHMTTheme ? HHMT_EMAIL : REMOX_EMAIL,
                  phone: isHHMTTheme ? HHMT_PHONE : REMOX_PHONE,
                  lang: locate,
                  link: t(
                    ADD_TRANSACTION_PAYMENT_METHOD_INSTRUCTION_LINK[theme][
                      method?.method
                    ]
                  ),
                }),
                [
                  {
                    key: 'email',
                    value: isHHMTTheme ? HHMT_EMAIL : REMOX_EMAIL,
                  },
                  {
                    key: 'phone',
                    value: isHHMTTheme ? HHMT_PHONE : REMOX_PHONE,
                  },
                  {
                    key: 'lang',
                    value: locate,
                  },
                  {
                    key: 'link',
                    value: t(
                      ADD_TRANSACTION_PAYMENT_METHOD_INSTRUCTION_LINK[theme][
                        method?.method
                      ]
                    ),
                  },
                  {
                    key: 'host',
                    value: HOME_URL[theme],
                  },
                ]
              ),
            }}
          />
        ),
      });
    };

    const paymentMethodItemClassName = `payment-method-item-${method?.method}`;
    const paymentMethodImageSubDesc = `image-sub-desc-${method?.method}`;
    // useTextScaleFontSize(
    //   paymentMethodImageSubDesc,
    //   paymentMethodItemClassName,
    //   '12px',
    //   '10px'
    // );

    const renderBodyContentComponent = () => {
      const getBodyContentOnClick = () => {
        if (
          method?.method === METHOD_DEPOSIT ||
          method?.method === METHOD_PAYID ||
          method?.method === METHOD_EPAYMENT
        )
          return;
        if (method?.method === METHOD_PAYTO) {
          setValidation(initialFormField);
          resetPaymentMethod();
          onShowAddPaytoAccountModal();
          return;
        }
        return;
      };
      const bodyContentComponentReferences = {
        [METHOD_PAYTO]: PaytoBodyContent,
      };
      const renderBodyContentCommon = () => {
        const renderPayLimitDesc = () => {
          if (isServiceAlertsOfPaymentMethodItemDisable) return null;
          const isPaytoBlocked =
            isArray(paytoAccountsAgreement) &&
            paytoAccountsAgreement?.some(
              (accountAgreement) => accountAgreement?.blocked
            );
          if (method?.method === METHOD_PAYTO && isPaytoBlocked) return null;
          if (method?.payLimitDesc && payLimit?.payLimitMax)
            return (
              <p
                className={`image-sub-desc ${paymentMethodImageSubDesc}`}
                style={{
                  whiteSpace: 'nowrap',
                }}
              >{`${
                payLimit?.feesIncluded
                  ? t(method.payLimitDestFeesIncluded)
                  : t(method.payLimitDestNotFeesIncluded)
              } ≤ ${format.toAmountCentStr(payLimit?.payLimitMax)} AUD`}</p>
            );
          return null;
        };
        return (
          <>
            {method?.label && (
              <p
                className="image-label"
                dangerouslySetInnerHTML={{
                  __html: stringUtils.replaceBreakLine(t(method?.label)),
                }}
              />
            )}
            {method?.desc && <p className="image-desc">{t(method?.desc)}</p>}
            {renderPayLimitDesc()}
          </>
        );
      };
      const BodyContentComponent =
        bodyContentComponentReferences?.[method?.method] || null;
      if (BodyContentComponent)
        return (
          <BodyContentComponent
            onClick={getBodyContentOnClick}
            renderBodyContentCommon={renderBodyContentCommon}
            handleShowPaymentInstructionModal={
              handleShowPaymentInstructionModal
            }
            isPayLimit={isPayLimit}
          />
        );
      if (isPayLimit) return <>{renderBodyContentCommon()}</>;
      return <>{renderBodyContentCommon()}</>;
    };

    const renderTagIcon = () => ({
      [METHOD_PAYTO]: () => {
        if (!isEmpty(paytoAccountsAgreement)) return null;
        if (isEmpty(method?.tagIcon)) return null;
        return (
          <TagIcon src={method?.tagIcon?.[locate]} width={62} height={30} />
        );
      },
    });

    if (isPayLimit) {
      return (
        <PaymentMethodItemStyled
          data-testid={`payment-method-${method?.method}`}
          data-selected={isSelected ? 'true' : 'false'}
          $isSelected={isSelected}
          $isDisabled={isDisabled}
          onClick={(e) => handlePaymentMethodDisabledSelected(e)}
          className={paymentMethodItemClassName}
        >
          <ImageWrap
            $isSelected={isSelected}
            $isDisabled={isDisabled}
            $isPayLimit={isPayLimit}
          >
            <img src={method?.icon} alt={method?.label} />
            {renderBodyContentComponent()}
          </ImageWrap>
          <InstructionImage
            className="question-icon"
            src={QuestionIcon}
            width={20}
            height={20}
            onClick={handleShowPaymentInstructionModal}
          />
        </PaymentMethodItemStyled>
      );
    }
    return (
      <>
        {isShowUrgentPopup && (
          <UrgentPopup
            isOpen={isShowUrgentPopup}
            onClose={() => setShowUrgentPopup(false)}
          />
        )}
        <PaymentMethodItemStyled
          data-testid={`payment-method-${method?.method}`}
          data-selected={isSelected ? 'true' : 'false'}
          $isSelected={isSelected}
          $isDisabled={isDisabled}
          $isRequired={!isDisabled && isSelectRequired}
          onClick={(e) => handlePaymentMethodSelected(e, method?.method)}
          className={paymentMethodItemClassName}
        >
          <ImageWrap $isSelected={isSelected} $isPayLimit={isPayLimit}>
            <img
              src={isSelected ? method?.iconColor : method?.icon}
              alt={method?.label}
            />
            {renderBodyContentComponent()}
          </ImageWrap>
          {renderTagIcon()?.[method?.method]?.()}
          <InstructionImage
            className="question-icon"
            src={QuestionIcon}
            width={isServiceAlertsOfPaymentMethodItemDisable ? 20 : 40}
            height={isServiceAlertsOfPaymentMethodItemDisable ? 20 : 40}
            onClick={handleShowPaymentInstructionModal}
            style={{
              zIndex: isEmpty(paytoAccountsAgreement) && 1,
            }}
          />
        </PaymentMethodItemStyled>
      </>
    );
  }
);

const PaymentMethodItemStyled = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  box-shadow: 0px 4px 15px 0px #0000001a;
  cursor: pointer;
  padding: 10px;
  position: relative;
  background-color: ${(props) => (props.$isSelected ? '#FEF0D1' : 'unset')};
  border: ${(props) =>
    props.$isRequired ? '1px solid var(--ds-c-red)' : '1px solid transparent'};
  ${(props) =>
    props.$isDisabled &&
    `
    background-color: #eeeeee;
    border: 1px solid transparent;
  `};

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    width: 206px;
    height: 162px;
  }
`;

const ImageWrap = styled.div`
  font-family: var(--ff-primary);
  font-style: normal;
  color: var(--ds-c-grey-dark);
  user-select: none;
  display: grid;
  align-items: center;
  justify-items: center;
  margin-top: 0px;
  width: 100%;

  & img {
    width: 62px;
    height: 50px;
    object-fit: contain;
    margin-bottom: 4px;
    ${(props) => props.$isDisabled && 'filter: grayscale(1)'};
  }

  & p.image-label {
    font-size: 16px;
    line-height: 20px;
    font-weight: 600;
    text-align: center;
    white-space: break-spaces;

    width: 100%;
    margin-bottom: 4px;

    @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
      font-size: 16px;
      line-height: 20px;
      width: 162px;
    }
  }

  & p.image-desc {
    font-size: 12px;
    line-height: 15px;
    font-weight: 500;
    text-transform: capitalize;

    margin-bottom: 0px;
  }

  & p.image-sub-desc {
    font-size: 10px;
    line-height: 15px;
    font-weight: 500;
    text-transform: capitalize;
    color: ${(props) =>
      props.$isPayLimit ? 'var(--ds-c-red)' : 'var(--ds-c-blue)'};

    margin-bottom: 0px;
    margin-top: 2px;
  }
`;

const InstructionImage = styled.img`
  align-self: end;
  padding: 10px;
  margin-right: -10px;
  margin-bottom: -10px;
  // z-index: 2;
  
  &:last-child {
    margin-top: -10px;
  }
}
`;
export const InstructionBodyContent = styled.div`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: var(--ds-c-grey-dark);

  width: 100%;
  padding-bottom: 8px;

  & p {
    cursor: text;
    margin: 0;
    padding: 0;
  }

  & p.instruction-title {
    font-weight: 600;
    text-transform: uppercase;
    color: var(--ds-c-green-default);
    margin-bottom: 20px;
  }

  & p.instruction-content {
  }

  & p.instruction-contact {
  }

  & a {
    color: var(--ds-c-blue-hyperlink-default) !important;
    text-decoration: none;
    text-transform: none;

    &:focus,
    &:focus-visible,
    &:active {
      color: var(--ds-c-blue-hyperlink-default) !important;
    }

    &:hover {
      color: var(--ds-c-blue-hyperlink-hover) !important;
    }
  }

  & span {
    font-weight: 700;
  }

  & span.warning {
    font-weight: 500;
    color: var(--ds-c-red);
  }

  & ol {
    margin: 0;
    padding-left: 24px;

    & li {
      list-style: auto;
      list-style-type: decimal;
    }
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    line-height: 20px;
  }
`;

const TagIcon = styled.img`
  width: 50px;
  height: 24px;
  object-fit: cover;
  position: absolute;
  top: -1px;
  right: -1px;
  border-radius: 0 8px;
`;

export default PaymentMethodItem;
